import { useEffect, useMemo, useState } from "react";
import { getModalKeysStorage, setModalKeysStorage } from "@/utils/storage";
import dayjs from "dayjs";
import { usePostBaobPcSupplyGetMessagePopup } from "@/openapi/baob/pc.Supply/api.client.hooks";
import ShopPerformanceModal from "@/components/Modal/SubModals/ShopPerformanceModal";
import { PostBaobPcSupplyGetMessagePopup200DataListItem } from "@/openapi/baob/pc.Supply/api.client.axios";
import { PAGES } from "@/constant/pages";
import { useModel } from "@umijs/max";
import { useLocation } from "@@/exports";

/**
 * 商品列表页弹窗类型枚举
 */
enum GlobalModalType {
  /**
   * 店铺履约
   */
  SHOP_PERFORMANCE = "shop_performance",
}

/**
 * 跳过全局弹窗的页面
 */
const skipPages = [PAGES.GOODS_CREATE, PAGES.GOODS_DETAIL];

const GlobalModals = () => {
  const router = useLocation();
  const { isAuthModalShown, setModalModel } = useModel("useModalModel");
  const [currentModalData, setCurrentModalData] =
    useState<PostBaobPcSupplyGetMessagePopup200DataListItem>(
      {} as PostBaobPcSupplyGetMessagePopup200DataListItem,
    );

  const [openModals, setOpenModals] = useState<
    Record<GlobalModalType, boolean>
  >(() => ({
    [GlobalModalType.SHOP_PERFORMANCE]: false,
  }));

  const isSkipPage = useMemo(() => {
    return skipPages.includes(router.pathname as PAGES);
  }, [router.pathname]);

  const handlePipelineModal = (
    list?: PostBaobPcSupplyGetMessagePopup200DataListItem[],
  ) => {
    const modalKeys = getModalKeysStorage();
    const nextModal = list?.find((item) => {
      // 判断弹窗无弹出记录，或者弹窗上次弹出时间早于今天，则此次需要弹出
      return (
        !modalKeys[item.type] ||
        dayjs(modalKeys[item.type]).isBefore(dayjs(), "day")
      );
    });
    if (nextModal) {
      setCurrentModalData(nextModal);
      setOpenModals((prevState) => ({
        ...prevState,
        [nextModal.type]: true,
      }));
    } else {
      // 如果没有下一个需要处理的弹窗，则更新全局弹窗显示状态
      setModalModel((prevState) => ({
        ...prevState,
        isGlobalModalShown: true,
      }));
    }
  };

  const { data: modalData, mutate: getGlobalModals } =
    usePostBaobPcSupplyGetMessagePopup({
      mutation: {
        onSuccess: (res) => {
          handlePipelineModal(res?.data?.list);
        },
      },
    });

  const handleClose = (type: GlobalModalType) => {
    // 当用户主动关闭时，更新弹窗显示记录
    setModalKeysStorage(type);
    setOpenModals((prevState) => ({
      ...prevState,
      [type]: false,
    }));
    // 继续调用下一个弹窗
    handlePipelineModal(modalData?.data?.list);
  };

  useEffect(() => {
    /**
     * 鉴权弹窗处理后，再请求全局弹窗数据
     */
    if (isAuthModalShown && !isSkipPage) {
      getGlobalModals({});
    }
  }, [getGlobalModals, isAuthModalShown, isSkipPage]);

  return (
    <>
      <ShopPerformanceModal
        key={GlobalModalType.SHOP_PERFORMANCE}
        open={openModals[GlobalModalType.SHOP_PERFORMANCE]}
        data={currentModalData}
        onClose={() => handleClose(GlobalModalType.SHOP_PERFORMANCE)}
      />
    </>
  );
};

export default GlobalModals;
